// src/components/AboutPage.jsx
import React from "react";
import { useEffect } from 'react';
import Header from "./Header";
import Footer from "./Footer";

const AboutPage = ({ setCurrentPage }) => {
   useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // 可选：平滑滚动
  }, []);
  return (
    <div>
      <Header currentPage="about" setCurrentPage={setCurrentPage} />

      <main className="pt-28 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* 标题区域 */}
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">关于西航投</h2>
            <div className="w-32 h-1 bg-gradient-to-r from-blue-600 via-purple-600 to-emerald-600 mx-auto rounded-full"></div>
          </div>

          {/* 公司概况 */}
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-10 mb-16 border border-gray-100">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">公司概况</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <OverviewCard
                title="基本信息"
                color="bg-blue-600"
                icon={
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                }
                items={[
                  { label: "公司名称", value: "西航投（云南）新能源有限公司" },
                  { label: "成立时间", value: "2025年03月24日" },
                  { label: "注册资本", value: "39860万人民币" },
                  { label: "法定代表人", value: "丁冬梅" },
                  { label: "员工规模", value: "约20人" },
                  { label: "公司性质", value: "有限责任公司" },
                ]}
              />
              <OverviewCard
                title="办公环境"
                color="bg-emerald-600"
                icon={
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                }
                items={[
                  { label: "注册地址", value: "云南省昆明市西山区西苑街道办事处秋苑二期2组团22幢2单元第4层403号" },
                  { label: "办公面积", value: "约500平方米现代化办公空间" },
                  { label: "办公设施", value: "配备先进的新能源市场开发团队和专业设备" },
                  { label: "办公环境", value: "开放式办公区、独立会议室、休闲区等" },
                ]}
              />
              <OverviewCard
                title="部门结构"
                color="bg-purple-600"
                icon={
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                }
                customContent={
                  <div className="text-left text-gray-700 text-base">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <p className="font-semibold mb-1">管理层</p>
                        <ul className="space-y-1">
                          <li>• 总经理室</li>
                          <li>• 副总经理室</li>
                          <li>• 书记办公室</li>
                        </ul>
                      </div>
                      <div>
                        <p className="font-semibold mb-1">职能部门</p>
                        <ul className="space-y-1">
                          <li>• 商务投资部</li>
                          <li>• 财务融资部</li>
                          <li>• 法务审计部</li>
                          <li>• 产业拓展部</li>
                          <li>• 综合办公室</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                }
              />
            </div>
          </div>

          {/* 母公司背景 */}
          <div className="bg-gradient-to-r from-gray-900 via-blue-900 to-emerald-900 rounded-3xl p-10 md:p-12 text-white mb-16 relative overflow-hidden">
            <div className="absolute inset-0 bg-black opacity-15"></div>
            <div className="relative z-10">
              <h3 className="text-3xl font-bold text-white mb-8 text-center">母公司背景</h3>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div>
                  <h4 className="text-2xl font-bold text-blue-200 mb-4">西安航空航天投资股份有限公司</h4>
                  <div className="space-y-4 text-base">
                    <div>
                      <h5 className="text-lg font-semibold text-white mb-2">成立背景</h5>
                      <p>成立于国家航空航天产业快速发展的背景下，响应国家号召，注册资本达数亿元，由多家知名企业和投资机构共同出资。</p>
                    </div>
                    <div>
                      <h5 className="text-lg font-semibold text-white mb-2">战略定位</h5>
                      <p>专注于航空航天领域的技术研发，推动行业创新，与国内外多家航空航天企业建立了战略合作关系。</p>
                    </div>
                    <div>
                      <h5 className="text-lg font-semibold text-white mb-2">业务范围</h5>
                      <ul className="space-y-1 list-disc list-inside text-blue-100">
                        <li>航天产品研发</li>
                        <li>航空制造与维护</li>
                        <li>卫星通信服务</li>
                        <li>投资与资产管理</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  <h4 className="text-2xl font-bold text-emerald-200 mb-4">西安航投未来资本管理集团</h4>
                  <div className="space-y-4 text-base">
                    <div>
                      <h5 className="text-lg font-semibold text-white mb-2">集团概况</h5>
                      <p>成立于2010年，专注于航空航天领域的投资与资产管理，主要业务包括股权投资、风险投资、产业基金等。</p>
                    </div>
                    <div>
                      <h5 className="text-lg font-semibold text-white mb-2">投资案例</h5>
                      <p>成功投资了多家航空航天科技公司，如某知名无人机制造商，推动了行业技术进步，计划进一步扩大投资规模。</p>
                    </div>
                    <div>
                      <h5 className="text-lg font-semibold text-white mb-2">产业支持</h5>
                      <ul className="space-y-1 list-disc list-inside text-emerald-100">
                        <li>航天技术投资</li>
                        <li>航空产业链支持</li>
                        <li>高新技术企业孵化</li>
                        <li>建设天空产业园</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 员工福利保障 */}
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-10 mb-16 border border-gray-100">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">员工福利保障</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                {
                  title: "健康保险",
                  desc: "为员工提供全面的健康保险计划，确保员工及家属医疗无忧，包括门诊、住院、重大疾病等保障。",
                  color: "bg-blue-100 text-blue-600 hover:bg-blue-200",
                },
                {
                  title: "退休金计划",
                  desc: "为员工退休后的生活提供稳定经济支持，公司按比例缴纳企业年金，确保退休生活质量。",
                  color: "bg-emerald-100 text-emerald-600 hover:bg-emerald-200",
                },
                {
                  title: "带薪休假",
                  desc: "享有国家规定的带薪年假、病假等，工作满一年享5天年假，逐年递增，保障员工休息和工作平衡。",
                  color: "bg-purple-100 text-purple-600 hover:bg-purple-200",
                },
                {
                  title: "培训发展",
                  desc: "提供各类培训和职业发展机会，包括专业技能培训、管理能力提升、行业前沿知识分享等，助力员工职业规划。",
                  color: "bg-amber-100 text-amber-600 hover:bg-amber-200",
                },
              ].map((item, idx) => (
                <div key={idx} className="text-center group">
                  <div className={`w-16 h-16 ${item.color.split(' ')[0]} rounded-2xl flex items-center justify-center mx-auto mb-4 transition-colors duration-300 group-hover:${item.color.split(' ')[2] || ''}`}>
                    <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      {idx === 0 && <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />}
                      {idx === 1 && <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />}
                      {idx === 2 && <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />}
                      {idx === 3 && <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />}
                    </svg>
                  </div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">{item.title}</h4>
                  <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* 社会责任 */}
          <div className="bg-gradient-to-r from-blue-600 to-emerald-600 rounded-3xl p-10 md:p-12 text-white mb-16 relative overflow-hidden">
            <div className="absolute inset-0 bg-black opacity-10"></div>
            <div className="relative z-10">
              <h3 className="text-3xl font-bold text-white mb-8 text-center">社会责任</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {[
                  {
                    title: "环保责任",
                    desc: "积极参与植树造林、林下经济等环保项目，每年组织员工参与环保公益活动，致力于减少碳足迹。",
                    icon: (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                    ),
                  },
                  {
                    title: "教育支持",
                    desc: "支持地方教育事业发展，设立奖学金，资助贫困学生，与高校建立产学研合作，培养新能源领域人才。",
                    icon: (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                    ),
                  },
                  {
                    title: "社区贡献",
                    desc: "积极参与社区建设，支持当地经济发展，为周边居民提供就业机会，组织志愿者服务活动，共建和谐社区。",
                    icon: (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                    ),
                  },
                ].map((item, idx) => (
                  <div key={idx} className="text-center">
                    <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                      <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        {item.icon}
                      </svg>
                    </div>
                    <h4 className="text-lg font-semibold text-white mb-2">{item.title}</h4>
                    <p className="text-blue-100 text-sm">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* 企业文化 */}
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-10 border border-gray-100">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">企业文化</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <CultureItem
                title="创新技术应用"
                desc="西航投（云南）新能源有限公司采用前沿技术，如高效光伏组件、智能储能系统、数字化运维平台等，推动能源产业创新。"
                points={[
                  "持续投入研发，与高校、科研院所建立合作关系",
                  "引进国际先进技术，结合云南本地特点进行优化",
                  "建立技术创新激励机制，鼓励员工提出创新方案",
                ]}
                bulletColor="bg-blue-600"
              />
              <CultureItem
                title="绿色发展理念"
                desc="公司坚持可持续发展，注重环保，致力于减少碳足迹，推动绿色能源的普及，实现经济效益与环境效益的双赢。"
                points={[
                  "所有项目均进行环境影响评估，确保符合环保标准",
                  "采用环保材料和节能设备，降低项目运营能耗",
                  "建立环境管理体系，定期进行环保审计和改进",
                ]}
                bulletColor="bg-emerald-600"
              />
            </div>
          </div>
        </div>
      </main>

      <Footer currentPage="about" setCurrentPage={setCurrentPage} />
    </div>
  );
};

// 公司概况卡片
const OverviewCard = ({ title, color, icon, items, customContent }) => (
  <div className="text-center">
    <div className={`w-16 h-16 ${color} rounded-2xl flex items-center justify-center mx-auto mb-4`}>
      {icon}
    </div>
    <h4 className="text-xl font-bold text-gray-900 mb-3">{title}</h4>
    {customContent ? (
      customContent
    ) : (
      <div className="text-left space-y-2 text-gray-700 text-base">
        {items.map((item, idx) => (
          <p key={idx}>
            <span className="font-semibold">{item.label}：</span>
            {item.value}
          </p>
        ))}
      </div>
    )}
  </div>
);

// 企业文化项
const CultureItem = ({ title, desc, points, bulletColor }) => (
  <div>
    <h4 className="text-xl font-bold text-gray-900 mb-3">{title}</h4>
    <p className="text-gray-700 text-base leading-relaxed mb-4">{desc}</p>
    <ul className="space-y-2 text-gray-700">
      {points.map((point, idx) => (
        <li key={idx} className="flex items-start">
          <span className={`w-2 h-2 ${bulletColor} rounded-full mt-2 mr-3 flex-shrink-0`}></span>
          <span className="text-base">{point}</span>
        </li>
      ))}
    </ul>
  </div>
);

export default AboutPage;